import {StrictMode} from 'react'
import ReactDOM from 'react-dom/client'
import {createRouter, RouterProvider} from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'primeicons/primeicons.css';
        

// Import the generated route tree
import {routeTree} from './routeTree.gen'

import './styles.css'
import reportWebVitals from './reportWebVitals.ts'
import {type AuthContextType, AuthProvider, useAuth} from "@/contexts/authContext.tsx";

// Create a new router instance
const router = createRouter({
    routeTree,
    context: {
        auth: undefined as unknown as AuthContextType,
    },
    defaultPreload: 'intent',
    scrollRestoration: true,
    defaultStructuralSharing: true,
    defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

const queryClient = new QueryClient()

function InnerApp() {
    const auth = useAuth();
    return <RouterProvider router={router} context={{auth}}/>;
}


// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
        <StrictMode>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <InnerApp/>
                </AuthProvider>
            </QueryClientProvider>
        </StrictMode>,
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
